import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function AboutPage() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51吃瓜网",
    url: "http://yuefenggroup.cn/",
    logo: "http://yuefenggroup.cn/logo.png",
    description:
      "51吃瓜网今日吃瓜资源聚合平台，提供最新爆料、热门黑料、每日大赛等吃瓜资讯",
    sameAs: ["http://yuefenggroup.cn/"],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "客户服务",
      email: "hello@yuefenggroup.cn",
      availableLanguage: "Chinese",
    },
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "关于我们 | 51吃瓜网",
    url: "http://yuefenggroup.cn/about",
    description: "了解51吃瓜网的品牌故事、网站声誉与联系方式",
    isPartOf: {
      "@type": "WebSite",
      name: "51吃瓜网",
      url: "http://yuefenggroup.cn/",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "51吃瓜网是什么？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "51吃瓜网是一个中文娱乐八卦与热点资讯聚合平台，聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题，按热度整理每日大赛、最新爆料与热门黑料，帮助用户快速定位今日最值得关注的爆料与娱乐热点。",
        },
      },
      {
        "@type": "Question",
        name: "51吃瓜网的内容来源可靠吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "51吃瓜网的内容来源于网络公开信息和网友爆料，我们致力于呈现多元视角。部分内容为匿名爆料，真实性有待验证，请读者自行判断。本站内容仅供娱乐参考，不代表任何立场。",
        },
      },
      {
        "@type": "Question",
        name: "51吃瓜网多久更新一次？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "51吃瓜网坚持每日更新，每日大赛、今日大瓜等板块会在每天上午和下午各更新一次，确保用户能够获取到最新的吃瓜资讯。热门事件发生时，我们会第一时间跟进报道。",
        },
      },
      {
        "@type": "Question",
        name: "如何联系51吃瓜网？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "您可以通过电子邮件 hello@yuefenggroup.cn 与我们联系。如果您有爆料线索，也欢迎通过该邮箱发送，我们会进行初步核实后决定是否发布。",
        },
      },
      {
        "@type": "Question",
        name: "51吃瓜网会删除文章吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "如果文章内容存在事实性错误或侵犯合法权益，经核实后我们会进行更正或删除处理。当事人或相关方可通过官方渠道联系我们提出申诉。",
        },
      },
    ],
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "http://yuefenggroup.cn/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "关于我们",
        item: "http://yuefenggroup.cn/about",
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 | 51吃瓜网今日吃瓜资源"
        description="了解51吃瓜网的品牌故事、网站声誉与联系方式。51吃瓜网是中文娱乐八卦与热点资讯聚合平台，聚焦今日大瓜、每日大赛等核心吃瓜专题。"
        keywords="51吃瓜网,关于我们,品牌介绍,网站声誉,联系我们,吃瓜平台"
        canonicalUrl="http://yuefenggroup.cn/about"
        ogTitle="关于我们 | 51吃瓜网"
        ogDescription="了解51吃瓜网的品牌故事、网站声誉与联系方式"
        lastModified="2026-07-02"
        schemaData={[orgSchema, webPageSchema, faqSchema, breadcrumbSchema]}
      />

      <Navbar />

      <main>
        {/* About Hero */}
        <section className="relative h-[280px] md:h-[380px] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                "url(https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20amber%20gradient%20with%20soft%20geometric%20shapes%2C%20modern%20minimalist%20background%2C%20editorial%20design%20style%2C%20gentle%20lighting%20and%20depth&width=1600&height=600&seq=about-hero&orientation=landscape)",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/30 via-background-950/20 to-background-950/40" />

          <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
              关于51吃瓜网
            </h1>
            <p className="text-base md:text-lg text-foreground-600 max-w-xl">
              了解我们的品牌故事、网站声誉与联系方式
            </p>
          </div>
        </section>

        {/* Breadcrumbs */}
        <section className="w-full px-4 md:px-8 py-6">
          <Breadcrumbs items={[{ label: "关于我们" }]} />
        </section>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-8 py-8 md:py-12">
          <div className="max-w-4xl mx-auto">
            <div className="mb-10">
              <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">
                品牌介绍
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2 mb-4">
                吃瓜，也是一种态度
              </h2>
              <p className="text-foreground-600 leading-relaxed text-base md:text-lg">
                51吃瓜网创立于对真实与娱乐的双重追求之中。我们相信，娱乐八卦不只是消遣，
                更是一面折射社会现象的镜子。从明星翻车到综艺黑幕，从网红翻车到选角内幕，
                51吃瓜网始终站在吃瓜的第一线，为用户筛选、整理、呈现最有价值的爆料与资讯。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20workspace%20with%20multiple%20computer%20screens%20showing%20data%20analytics%2C%20warm%20amber%20and%20coral%20accent%20lighting%2C%20clean%20minimalist%20design%2C%20editorial%20photography&width=600&height=400&seq=about-img-01&orientation=landscape"
                  alt="51吃瓜网编辑团队"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20nodes%20connected%20by%20glowing%20lines%2C%20warm%20coral%20and%20gold%20color%20palette%2C%20representing%20information%20flow%20and%20connectivity%2C%20modern%20digital%20art%20style&width=600&height=400&seq=about-img-02&orientation=landscape"
                  alt="51吃瓜网信息平台"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="mb-10">
              <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">
                网站声誉
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2 mb-4">
                值得信赖的吃瓜平台
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
                <div className="text-center p-4 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    100万+
                  </div>
                  <div className="text-sm text-foreground-600">日均访问量</div>
                </div>
                <div className="text-center p-4 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-accent-500 mb-1">
                    500+
                  </div>
                  <div className="text-sm text-foreground-600">累计文章</div>
                </div>
                <div className="text-center p-4 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-secondary-500 mb-1">
                    6
                  </div>
                  <div className="text-sm text-foreground-600">核心分类</div>
                </div>
                <div className="text-center p-4 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    365天
                  </div>
                  <div className="text-sm text-foreground-600">全年无休</div>
                </div>
              </div>
              <p className="text-foreground-600 leading-relaxed">
                51吃瓜网以「快速、真实、有趣」为核心价值观，坚持每日更新，确保用户不会错过任何一个值得吃的瓜。
                我们的编辑团队由资深娱乐记者和网络舆情分析师组成，能够从海量信息中精准筛选出最具话题性的内容。
                同时，我们建立了完善的信息核实机制，对每条爆料进行初步溯源，最大程度保证内容的真实性。
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">
              常见问题
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2 mb-8">
              FAQ
            </h2>

            <div className="space-y-4">
              {[
                {
                  q: "51吃瓜网是什么？",
                  a: "51吃瓜网是一个中文娱乐八卦与热点资讯聚合平台，聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题，按热度整理每日大赛、最新爆料与热门黑料，帮助用户快速定位今日最值得关注的爆料与娱乐热点。",
                },
                {
                  q: "51吃瓜网的内容来源可靠吗？",
                  a: "51吃瓜网的内容来源于网络公开信息和网友爆料，我们致力于呈现多元视角。部分内容为匿名爆料，真实性有待验证，请读者自行判断。本站内容仅供娱乐参考，不代表任何立场。",
                },
                {
                  q: "51吃瓜网多久更新一次？",
                  a: "51吃瓜网坚持每日更新，每日大赛、今日大瓜等板块会在每天上午和下午各更新一次，确保用户能够获取到最新的吃瓜资讯。热门事件发生时，我们会第一时间跟进报道。",
                },
                {
                  q: "如何联系51吃瓜网？",
                  a: "您可以通过电子邮件 hello@yuefenggroup.cn 与我们联系。如果您有爆料线索，也欢迎通过该邮箱发送，我们会进行初步核实后决定是否发布。",
                },
                {
                  q: "51吃瓜网会删除文章吗？",
                  a: "如果文章内容存在事实性错误或侵犯合法权益，经核实后我们会进行更正或删除处理。当事人或相关方可通过官方渠道联系我们提出申诉。",
                },
              ].map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 pr-4">
                      {faq.q}
                    </h3>
                    <i className="ri-add-line text-foreground-400 group-open:ri-subtract-line text-xl flex-shrink-0" />
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">
              联系方式
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2 mb-6">
              联系我们
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 bg-background-100 rounded-lg text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mx-auto mb-3">
                  <i className="ri-mail-line text-xl" />
                </div>
                <h3 className="font-semibold text-foreground-900 mb-1">电子邮件</h3>
                <p className="text-sm text-foreground-600">hello@yuefenggroup.cn</p>
              </div>
              <div className="p-6 bg-background-100 rounded-lg text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mx-auto mb-3">
                  <i className="ri-time-line text-xl" />
                </div>
                <h3 className="font-semibold text-foreground-900 mb-1">工作时间</h3>
                <p className="text-sm text-foreground-600">每日更新 · 全天无休</p>
              </div>
              <div className="p-6 bg-background-100 rounded-lg text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mx-auto mb-3">
                  <i className="ri-map-pin-line text-xl" />
                </div>
                <h3 className="font-semibold text-foreground-900 mb-1">服务范围</h3>
                <p className="text-sm text-foreground-600">中国大陆 · 全球中文用户</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
